import React from "react";
import Layout from "Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { withRouter } from "react-router";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import MuiAlert from "@material-ui/lab/Alert";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(2),
  },
}));

function Users(props) {
  const { request } = useApi();
  const { state } = useAuth();
  const classes = useStyles();

  const [users, setUsers] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - ユーザアカウント管理";

    fetchUsers();
    if (props.location.search.indexOf("create") > -1) {
      setSuccess("create");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess("edit");
    }
  }, [state.user.account_id]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  const openDialog = (id) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  const fetchUsers = () => {
    if (!state.user.account_id) {
      return;
    }
    
    request({
      method: "GET",
      url: `config/:account_id/users`,
    }).then((data) => {
      setUsers(data.data);
    });
  };

  const deleteUser = () => {
    request({
      method: "DELETE",
      url: `config/:account_id/users/${deleteId}`,
    }).then(() => {
      fetchUsers();
      setIsShowModal(false);
    });
  };

  // ユーザ登録ボタンのdisableチェック
  const createButtonDisable = () => {
    if (state.maxUsers <= users.length) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                ユーザ一覧
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>No.</TableCell>
                    <TableCell>ユーザ名</TableCell>
                    <TableCell>メールアドレス</TableCell>
                    <TableCell>権限</TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((row, index) => {
                    let userType = "一般";
                    
                    if (row.master) {
                      userType = "マスタ";
                    } else if(row.user_type === "admin"){
                      userType = "管理者";
                    }

                    return (
                      <TableRow key={row.id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>{userType}</TableCell>
                        <TableCell>
                          <ButtonGroup variant="contained" color="primary">
                            <Button
                              onClick={() =>
                                props.history.push(
                                  `/config/update_user/${row.id}`
                                )
                              }
                              disabled={row.master && !state.user.master}
                            >
                              編集
                            </Button>
                            <Button
                              color="secondary"
                              disabled={row.master}
                              onClick={() => openDialog(row.id)}
                            >
                              削除
                            </Button>
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    )}
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {success === "edit" ? "更新" : "登録"}が完了しました
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => props.history.push(`/config/create_user`)}
                disabled={createButtonDisable()}
              >
                ユーザ登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={deleteUser}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Users);
